<template>
	<div class="">
		<MediaTypeForm 
			@submit="$emit('submit', $event)"
            :class="senderTypeClass"
        	:message="message"
		/>
	</div>
</template>
<script>
import MediaTypeForm from './MediaTypeForm';

export default {
	components: {
		MediaTypeForm
	},
	props: {
		message: {
			type: Object,
			required: true,
		},
		senderTypeClass: {
			type: String,
			required: true,
		}
	}
}
</script>
<style lang="scss" >
</style>